var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mobile-navigation__wrapper d-lg-none" }, [
    _c(
      "div",
      {
        staticClass: "mobile-navigation",
        class: { open: _vm.isMobileNavigationOpen },
      },
      [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isNavigationInitialized,
                expression: "isNavigationInitialized",
              },
            ],
          },
          [
            _c("ul", { staticClass: "breadcrumb" }, [
              _c(
                "li",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.dataContainer1.parent,
                      expression: "!dataContainer1.parent",
                    },
                  ],
                  staticClass: "align-items-center",
                  class: { "d-flex": !_vm.dataContainer1.parent },
                },
                [
                  _c(
                    "client-only",
                    [
                      _c("od-portal-target", {
                        attrs: { name: "mobile-b2b-select" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.dataContainer1.parent && _vm.dataContainer1.parent.url
                ? _c(
                    "li",
                    {
                      staticClass: "ddown w-100",
                      on: {
                        click: function ($event) {
                          _vm.slideTo(
                            (_vm.dataContainer1.parent &&
                              _vm.dataContainer1.parent.parent) ||
                              null,
                            true
                          )
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "mobile-navigation__back" }, [
                        _c(
                          "svg",
                          { attrs: { xmlns: "http://www.w3.org/2000/svg" } },
                          [
                            _c("use", {
                              attrs: {
                                "xmlns:xlink": "http://www.w3.org/1999/xlink",
                                "xlink:href": "#svg-caret",
                              },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            attrs: {
                              href: _vm.getCategoryUrl(
                                _vm.dataContainer1.parent.url
                              ),
                              title: _vm.dataContainer1.parent.details[0].name,
                            },
                          },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  _vm.dataContainer1.parent.details[0].name
                                ) +
                                "\n                        "
                            ),
                          ]
                        ),
                      ]),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "li",
                {
                  staticClass: "mobile-navigation__close",
                  on: {
                    click: function ($event) {
                      return _vm.closeNavigation()
                    },
                  },
                },
                [
                  _c(
                    "svg",
                    { attrs: { xmlns: "http://www.w3.org/2000/svg" } },
                    [
                      _c("use", {
                        attrs: {
                          "xmlns:xlink": "http://www.w3.org/1999/xlink",
                          "xlink:href": "#svg-x",
                        },
                      }),
                    ]
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c(
              "ul",
              {
                directives: [{ name: "menu", rawName: "v-menu" }],
                staticClass: "mainmenu w-100 m-0 menu-active",
                attrs: { id: "menu-1" },
              },
              [
                _vm.dataContainer1.parent &&
                _vm.manufacturerCategories.includes(
                  _vm.dataContainer1.parent.id
                )
                  ? [
                      _c("li", [
                        _c(
                          "a",
                          {
                            staticClass: "ddown__link ddown__link--big",
                            attrs: {
                              href: _vm.getCategoryUrl(
                                _vm.dataContainer1.parent.url
                              ),
                            },
                          },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  _vm.dataContainer1.parent.details[0].name
                                ) +
                                "\n                        "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "ddown__divider" }, [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$translate(
                                  "OD3dprimaV2::Template.mobileMenuDivider2"
                                )
                              )
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "ul",
                          { staticClass: "ddown__list" },
                          [
                            _vm._l(
                              _vm.dataContainer1.categories,
                              function (category) {
                                return [
                                  category.details[0].name.toLowerCase() ==
                                    "other" ||
                                  category.details[0].name.toLowerCase() ==
                                    "others" ||
                                  category.details[0].name.toLowerCase() ==
                                    "weitere" ||
                                  category.details[0].name.toLowerCase() ==
                                    "övriga" ||
                                  category.id == 1519 ||
                                  category.id == 1520
                                    ? _c(
                                        "li",
                                        { staticClass: "ddown__item-full" },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticClass: "ddown__more-btn",
                                              attrs: {
                                                href: _vm.getCategoryUrl(
                                                  category.url
                                                ),
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(
                                                    category.details[0].name
                                                  ) +
                                                  "\n                                    "
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _c("li", [
                                        _c(
                                          "a",
                                          {
                                            staticClass: "ddown__list-link",
                                            attrs: {
                                              href: _vm.getCategoryUrl(
                                                category.url
                                              ),
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                        " +
                                                _vm._s(
                                                  category.details[0].name
                                                ) +
                                                "\n                                    "
                                            ),
                                          ]
                                        ),
                                      ]),
                                ]
                              }
                            ),
                          ],
                          2
                        ),
                      ]),
                    ]
                  : _vm.dataContainer1.parent &&
                    _vm.dataContainer1.parent.parent &&
                    _vm.filamentCategories.includes(
                      _vm.dataContainer1.parent.parent.id
                    )
                  ? [
                      _c("li", [
                        _c(
                          "a",
                          {
                            staticClass: "ddown__link ddown__link--big",
                            attrs: {
                              href: _vm.getCategoryUrl(
                                _vm.dataContainer1.parent.url
                              ),
                            },
                          },
                          [
                            _c(
                              "svg",
                              {
                                attrs: { xmlns: "http://www.w3.org/2000/svg" },
                              },
                              [
                                _c("use", {
                                  attrs: {
                                    "xmlns:xlink":
                                      "http://www.w3.org/1999/xlink",
                                    "xlink:href":
                                      "#svg-nav-" +
                                      _vm.dataContainer1.parent.id,
                                  },
                                }),
                              ]
                            ),
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  _vm.dataContainer1.parent.details[0].name
                                ) +
                                "\n                        "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "ddown__divider" }, [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$translate(
                                  "OD3dprimaV2::Template.mobileMenuDivider"
                                )
                              )
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "ul",
                          { staticClass: "ddown__list" },
                          [
                            _vm._l(
                              _vm.dataContainer1.categories,
                              function (category) {
                                return [
                                  category.details[0].name.toLowerCase() ==
                                    "other" ||
                                  category.details[0].name.toLowerCase() ==
                                    "others" ||
                                  category.details[0].name.toLowerCase() ==
                                    "weitere" ||
                                  category.details[0].name.toLowerCase() ==
                                    "övriga" ||
                                  category.id == 1519 ||
                                  category.id == 1520 ||
                                  category.id == 1158 ||
                                  category.id == 1064 ||
                                  category.id == 1038
                                    ? _c(
                                        "li",
                                        { staticClass: "ddown__item-full" },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticClass: "ddown__more-btn",
                                              attrs: {
                                                href: _vm.getCategoryUrl(
                                                  category.url
                                                ),
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(
                                                    category.details[0].name
                                                  ) +
                                                  "\n                                    "
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _c("li", [
                                        _c(
                                          "a",
                                          {
                                            staticClass: "ddown__list-link",
                                            attrs: {
                                              href: _vm.getCategoryUrl(
                                                category.url
                                              ),
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                        " +
                                                _vm._s(
                                                  category.details[0].name
                                                ) +
                                                "\n                                    "
                                            ),
                                          ]
                                        ),
                                      ]),
                                ]
                              }
                            ),
                          ],
                          2
                        ),
                      ]),
                    ]
                  : _vm._l(_vm.dataContainer1.categories, function (category) {
                      return (!_vm.dataContainer1.parent &&
                        _vm.menuCategories.includes(category.id)) ||
                        _vm.dataContainer1.parent
                        ? _c("li", { staticClass: "ddown" }, [
                            _c(
                              "a",
                              {
                                staticClass: "ddown__link",
                                class: {
                                  "ddown__link--big":
                                    _vm.dataContainer1.parent &&
                                    _vm.dataContainer1.parent.parent &&
                                    _vm.hardwareCategories.includes(
                                      _vm.dataContainer1.parent.parent.id
                                    ),
                                },
                                attrs: {
                                  href: _vm.getCategoryUrl(category.url),
                                },
                              },
                              [
                                _vm.dataContainer1.parent &&
                                _vm.dataContainer1.parent.parent &&
                                _vm.hardwareCategories.includes(
                                  _vm.dataContainer1.parent.parent.id
                                ) &&
                                category.details[0].image2Path
                                  ? _c(
                                      "svg",
                                      {
                                        attrs: {
                                          xmlns: "http://www.w3.org/2000/svg",
                                        },
                                      },
                                      [
                                        _c("use", {
                                          attrs: {
                                            "xmlns:xlink":
                                              "http://www.w3.org/1999/xlink",
                                            "xlink:href":
                                              "#svg-nav-" + category.id,
                                          },
                                        }),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(category.details[0].name) +
                                    "\n                        "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            category.childCount > 0
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "ddown__cta",
                                    on: {
                                      click: function ($event) {
                                        return _vm.slideTo(category)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "svg",
                                      {
                                        attrs: {
                                          xmlns: "http://www.w3.org/2000/svg",
                                        },
                                      },
                                      [
                                        _c("use", {
                                          attrs: {
                                            "xmlns:xlink":
                                              "http://www.w3.org/1999/xlink",
                                            "xlink:href": "#svg-caret",
                                          },
                                        }),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ])
                        : _vm._e()
                    }),
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "ul",
              {
                directives: [{ name: "menu", rawName: "v-menu" }],
                staticClass: "mainmenu w-100 m-0",
                attrs: { id: "menu-2" },
              },
              _vm._l(_vm.dataContainer2.categories, function (category) {
                return _c("li", { staticClass: "ddown" }, [
                  _c(
                    "a",
                    {
                      staticClass: "ddown__link",
                      attrs: { href: _vm.getCategoryUrl(category.url) },
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(category.details[0].name) +
                          "\n                    "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  category.childCount > 0
                    ? _c(
                        "span",
                        {
                          staticClass: "ddown__cta",
                          on: {
                            click: function ($event) {
                              return _vm.slideTo(category)
                            },
                          },
                        },
                        [
                          _c(
                            "svg",
                            { attrs: { xmlns: "http://www.w3.org/2000/svg" } },
                            [
                              _c("use", {
                                attrs: {
                                  "xmlns:xlink": "http://www.w3.org/1999/xlink",
                                  "xlink:href": "#svg-caret",
                                },
                              }),
                            ]
                          ),
                        ]
                      )
                    : _vm._e(),
                ])
              }),
              0
            ),
          ]
        ),
        _vm._v(" "),
        !_vm.isNavigationInitialized
          ? [
              _c("ul", { staticClass: "breadcrumb" }, [
                _c("li", {
                  staticClass: "btn-close",
                  on: {
                    click: function ($event) {
                      return _vm.closeNavigation()
                    },
                  },
                }),
              ]),
              _vm._v(" "),
              _c("loading-animation"),
            ]
          : _vm._e(),
      ],
      2
    ),
    _vm._v(" "),
    _c("div", {
      staticClass: "mobile-navigation__overlay",
      on: {
        click: function ($event) {
          return _vm.closeNavigation()
        },
      },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }